import { Button, SAPLogo } from '@platform/components';
import { MovingWorldsBannerLogo } from '../../layout/MovingWorldsLogo';

type HeroSectionProps = {
  dashboardHref: string;
};

export const HeroSection = ({ dashboardHref }: HeroSectionProps) => {
  return (
    <section className='flex flex-col items-center px-4 py-8 sm:px-6 md:px-8 md:py-10'>
      <div className='flex flex-col items-center gap-4 md:gap-6'>
        <div className='flex flex-col items-center gap-3 md:gap-4'>
          <div className='flex flex-wrap items-center justify-center gap-3 md:h-[43px] md:gap-5'>
            <div className='w-[72px] md:w-[97px]'>
              <SAPLogo />
            </div>
            <div className='hidden h-[43px] w-px bg-gray-200 md:block' />
            <div className='w-[160px] text-brand-500 md:w-[224px]'>
              <MovingWorldsBannerLogo />
            </div>
          </div>
          <h1 className='max-w-[780px] text-center text-4xl font-bold leading-[1.125] tracking-[-0.02em] text-gray-600 sm:text-5xl md:text-6xl xl:text-7xl'>
            Acceleration
            <br />
            Collective
          </h1>
          <p className='text-center text-base font-bold uppercase leading-6 tracking-[0.01em] text-gray-400 md:text-xl'>
            Powered by Movingworlds
          </p>
        </div>
        <span className='md:hidden'>
          <Button variant='primary' size='lg' href={dashboardHref}>
            Open program dashboard
          </Button>
        </span>
        <span className='hidden md:inline-flex'>
          <Button variant='primary' size='xl' href={dashboardHref}>
            Open program dashboard
          </Button>
        </span>
      </div>
    </section>
  );
};
